export const NAME = "user"
export const FIREBASE_PATH = "users"
